import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ReportComponent from './view/report-view';

const ReportRoutes = () => (
    <ErrorBoundaryRoutes>
        <Route index element={<ReportComponent />} />
    </ErrorBoundaryRoutes>
);

export default ReportRoutes;
